<template>
  <div id="contenedor-contratos-picker">
    <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-autocomplete
      v-model="contratosSeleccionados"
      :label="getLabel"
      :items="getContratos"
      return-object
      :multiple="multiSelect"
      filled
      clearable
      :disabled="isDisabled"
      color="#6A83B5"
      background-color="#F2F6FF"
      :item-text="shortTitle ? 'numero' : 'title'"
      :filter="filtro"
      :search-input.sync="search"
      @change="enviarSeleccionados">
      <template
        v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.numero }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.meta.slice(0,50) }}...
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    </v-col>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosPicker.gql';

export default {
  name: 'ContratosPicker',
  data() {
    return {
      contratosSeleccionados: [],
      search: '',
    };
  },
  props: {
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    shortTitle: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    filtro(item, queryText) {
      const numero = item.numero.toLowerCase();
      const meta = item.meta.toLowerCase();
      const expt = new RegExp(queryText, 'gi');
      return expt.test(numero) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('input', this.contratosSeleccionados);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-ids', this.contratosSeleccionados.map((contrato) => contrato.id));
      } else if (this.contratosSeleccionados !== null) {
        this.$emit('solo-ids', [this.contratosSeleccionados.id]);
      } else {
        this.$emit('solo-ids', []);
      }
      // this.contratosSeleccionados = [];
    },
  },
  apollo: {
    contratos: {
      query: CONTRATOS,
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar contrato(s)';
      return 'Seleccionar contrato';
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos
        .map((contrato) => ({
          id: contrato.id,
          numero: contrato.numero,
          ejercicio: contrato.ejercicio,
          meta: contrato.meta,
          title: `${contrato.numero} - ${contrato.meta}`,
        }));
    },
  },
  watch: {
    contratosSeleccionados() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">
</style>
